import { render, staticRenderFns } from "./UiPlatformList.vue?vue&type=template&id=4dca0e74&scoped=true"
import script from "./UiPlatformList.vue?vue&type=script&lang=ts"
export * from "./UiPlatformList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dca0e74",
  null
  
)

export default component.exports